import { ExerciseErrorType, ExerciseResultError } from "../../models/ExerciseResult/ExerciseResultError";

export function filterExerciseResultErrorsByTypes(errors: ExerciseResultError[], types: ExerciseErrorType[]): ExerciseResultError[] {
  return errors.filter(({ errorTypeId }) => types.includes(errorTypeId));
}